import { Injectable } from '@angular/core';
import { awsconfig, environment, federatedSignInConfig, oAuthConfig } from 'src/environments/environment';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root',
})
export class AuthConfig {
  private static instance: AuthConfig;

  federatedSignIn = federatedSignInConfig;
  awsAmplify = awsconfig;
  oAuthConfig = oAuthConfig;

  constructor(
    private logger: NGXLogger
  ) {
    this.logger.info(`[AuthConfig] constructor. Env: ${environment.name} Runtime: ${environment.runtime}`);
  }

  /* istanbul ignore next */
  public static getInstance(logger: NGXLogger): AuthConfig {
    if (!AuthConfig.instance) {
      AuthConfig.instance = new AuthConfig(logger);
    }
    return AuthConfig.instance;
  }
}
